import createReactComponent from '../createReactComponent';
export default createReactComponent('move-diagonal-one', 'MoveDiagonalOne', [["path",{"d":"M11 5H5v6m0-6 14 14m-6 0h6v-6","key":"svg-0"}]]);